// Firebase configuration for "Dober pogled app"
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// Firebase config from environment variables with fallback
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAix6Jz2M8ZYcY3AQ8IAmrDScN0iB63KB0",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "ldrakek-ffcm.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "ldrakek-ffcm",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "ldrakek-ffcm.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "585756696386",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:585756696386:web:d1505630f63c6995a1f2db",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-WTYNEWQKHK"
};

// VAPID key for push notifications
const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY || 'BLBx-hf5h_Fk4F0LNVGjkKFJvLlsWwSzrH7YrXsQKjYFmQgJZpZDPCWYlFRKJJvKKD8RyJnGQvBZGJwwWkGJPHo';

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging
let messaging = null;

// Check if browser supports notifications
export const isNotificationSupported = () => {
  try {
    // V opaque-origin sandboxed iframe-u dostop do navigator.serviceWorker vrže SecurityError
    return 'Notification' in window && 'serviceWorker' in navigator;
  } catch (_) {
    return false;
  }
};

// Initialize messaging only if supported
export const initializeMessaging = async () => {
  if (!isNotificationSupported()) {
    console.log('Push notifications not supported in this browser');
    return null;
  }
  
  try {
    messaging = getMessaging(app);
    return messaging;
  } catch (error) {
    console.error('Error initializing messaging:', error);
    return null;
  }
};

// Request permission and get FCM token
export const requestNotificationPermission = async () => {
  if (!isNotificationSupported()) {
    return null;
  }

  try {
    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      if (!messaging) {
        await initializeMessaging();
      }
      
      if (messaging) {
        // Get FCM token
        const token = await getToken(messaging, {
          vapidKey: VAPID_KEY
        });
        return token;
      }
    }
    return null;
  } catch (error) {
    console.error('Error requesting notification permission:', error);
    return null;
  }
};

// Listen for foreground messages
export const onMessageListener = () => {
  return new Promise((resolve) => {
    if (!messaging) {
      resolve(null);
      return;
    }
    
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
};

export { app, messaging };
